
export default {
  maps: {
    'pageTitle': 'CycleAI',
    'Places': 'Lugares',
    'isochrones': 'Isócronas',
    'placeNameRequired': 'Nombre del lugar solicitado',
    'altitude': 'Variación de la altitud',
    'settings': 'Opciones',
    'toggleAccessibleMode': 'Activar/desactivar el modo de accesibilidad',
    'about': 'Acerca de ORS',
    'updateSearch': 'Buscar en esta zona',
    'updateSearchAfterZoomOrCenterChange': 'Refrescar la búsqueda después de cambiar el centro'
  }
}
